import React from 'react';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';

import { MCTeamLineups } from '../components/MCTeamLineups';

export const MCTeamLineupsProvider = ({ store, data }) => (
    <Provider store={store}>
        <MCTeamLineups {...data} />
    </Provider>
);

MCTeamLineupsProvider.propTypes = {
    store: PropTypes.object.isRequired,
    data: PropTypes.object
};
